import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import CustomTable from '../../helpers/custom-table'
import { catchError } from '../../helpers/catch-error'
import DatePicker from "react-datepicker";
import { NavLink } from "react-router-dom";
import { CSVLink } from "react-csv";
import TopBar from './top-bar';


const RecordsInvoiceNeeded = () => {
    const navigate = useNavigate();
    const role = parseInt(localStorage.getItem('@admin_role'), 10);

    var columns = React.useMemo(
        () => [
            {
                accessorFn: row => <a onClick={() => {
                    if (row.is_updated == 1)
                        updateWorkOrder(row.work_order_id);
                }
                }
                    className={row.is_updated == 1 ? "fw-bold text-shadow text-danger" : ""}
                    href={"/admin/work-order/" + row.work_order_id} >{row.work_order_no}</a>,
                id: "work_order_id",
                cell: info => info.getValue(),
                header: () => "ID",
                footer: props => props.column.id,
            },
            {
                accessorFn: row => row.patient_last_name + ", " + row.patient_first_name + "__" + row.wo_policy_number,
                id: "patient_policy",
                cell: ({ getValue }) => (
                    <span>
                        <ul className="table-ul">
                            {(getValue().split("__")).map((p, index) => (
                                <li key={index}>{p}</li>
                            ))}
                        </ul>
                    </span>
                ),
                header: () => "Patient/Policy#",
                footer: props => props.column.id
            },
            {
                accessorFn: row => row.status == 4 ? "WAITING TO BE INVOICED" :
                    (row.status == 5 ? "INVOICE GENERATED" : "PAYMENT(S) RECEIVED"
                    ),
                id: "status",
                cell: info => info.getValue(),
                header: () => "Status",
                footer: props => props.column.id
            },
            {
                accessorKey: "copy_date_set_by",
                header: "Copy Date Set By",
                footer: props => props.column.id
            },
            {
                accessorKey: "client_company_name",
                header: "Client",
                footer: props => props.column.id
            },
            {
                accessorKey: "facility_name",
                header: "FACILITY",
                footer: props => props.column.id
            }



        ],
        []
    )


    const [data, setData] = useState(null);
    const [csvData, setCsvData] = useState(null);
    const [isBtn, setIsBtn] = useState(false);
    const [csvHeader, setCsvHeader] = useState([
        { label: "CASE NUMBER", key: "work_order_id" },
        { label: "PATIENT NAME", key: "patient_name" },
        { label: "POLICY NUMBER", key: "wo_policy_number" },
        { label: "CLIENT REFERENCE NUMBER", key: "client_reference_number" },
        { label: "FACIILITY INFORMATION", key: "facility_name" },
        { label: "CLIENT INFORMATION", key: "client_company_name" },
        { label: "INVOICE DATE", key: "invoice_date" },
        { label: "FACILITY FEE", key: "invoice_facility_fee" },
        { label: "CLIENT FEE", key: "invoice_client_fee" },
        { label: "MISC FEE", key: "invoice_misc_fee" },
        { label: "TOTAL FEES", key: "invoice_total" },
        { label: "T/F", key: "is_dollar_40" }
    ]);
    let d = new Date();
    const formatted_today = (d.getMonth() + 1).toString().padStart(2, "0") + '/' + d.getDate().toString().padStart(2, "0") + '/' + d.getFullYear();
    const [woSearch, setWoSearch] = useState({
        to: formatted_today,
    });


    const formatCurrency = (value) => {
        return `$${parseFloat(value || 0).toFixed(2)}`;
    };

    const getWorkOrders = async () => {

        await axios.post(
            process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-records-invoice-needed",
            {},
            { withCredentials: true }
        )
            .then(function (response) {

                if (response?.data?.status) {

                    setData(response?.data?.work_orders);
                    setCsvData([]);

                    response?.data?.work_orders?.forEach((wo) => {

                        const facilityFee = parseFloat(wo?.invoice_facility_fee || 0);
                        const clientFee = parseFloat(wo?.invoice_client_fee || 0);
                        const miscFee = parseFloat(wo?.invoice_misc_fee || 0);
                        const total = facilityFee + clientFee + miscFee;

                        let new_wo = {
                            work_order_id: wo.work_order_no,
                            patient_name: `${wo.patient_last_name}, ${wo.patient_first_name} ${wo.patient_middle_name}`,
                            wo_policy_number: wo?.wo_policy_number || "",
                            client_reference_number: wo?.client_reference_number || "",
                            facility_name: wo.facility_name,
                            client_company_name: wo.client_company_name,
                            invoice_date: wo.invoice_date,

                            invoice_facility_fee: formatCurrency(facilityFee),
                            invoice_client_fee: formatCurrency(clientFee),
                            invoice_misc_fee: formatCurrency(miscFee),
                            invoice_total: formatCurrency(total),

                            is_dollar_40: wo.is_dollar_40
                        };

                        setCsvData((csvData) => [...csvData, new_wo]);
                    });

                } else {
                    Swal.fire({ icon: "error", title: "Records Obtained Work Order Failed to Load" });
                }

            })
            .catch(function (error) {
                catchError(error, navigate);
            });
    };

    const updateWorkOrder = async (work_order_id) => {

        await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/update-is-updated-work-order", {
            work_order_id: work_order_id
        }, {
            withCredentials: true
        })
            .then(function (response) {

                if (response?.data?.status) {

                    getWorkOrders();

                } else {

                    Swal.fire({ icon: "error", title: "unable to update work order status" });

                }

            })
            .catch(function (error) {

                catchError(error, navigate)
            });


    }

    const getWorkOrdersFiltered = async () => {

        setIsBtn(true);

        await axios.post(
            process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-records-invoice-needed",
            woSearch,
            { withCredentials: true }
        )
            .then(function (response) {

                if (response?.data?.status) {

                    setData(response?.data?.work_orders);
                    setCsvData([]);

                    response?.data?.work_orders?.forEach((wo) => {

                        const facilityFee = parseFloat(wo?.invoice_facility_fee || 0);
                        const clientFee = parseFloat(wo?.invoice_client_fee || 0);
                        const miscFee = parseFloat(wo?.invoice_misc_fee || 0);
                        const total = facilityFee + clientFee + miscFee;

                        let new_wo = {
                            work_order_id: wo.work_order_no,
                            patient_name: `${wo.patient_last_name}, ${wo.patient_first_name} ${wo.patient_middle_name}`,
                            wo_policy_number: wo?.wo_policy_number,
                            client_reference_number: wo?.client_reference_number,
                            facility_name: wo.facility_name,
                            client_company_name: wo.client_company_name,
                            invoice_date: wo.invoice_date,

                            invoice_facility_fee: formatCurrency(facilityFee),
                            invoice_client_fee: formatCurrency(clientFee),
                            invoice_misc_fee: formatCurrency(miscFee),
                            invoice_total: formatCurrency(total),

                            is_dollar_40: wo.is_dollar_40
                        };

                        setCsvData((csvData) => [...csvData, new_wo]);
                    });

                } else {
                    Swal.fire({ icon: "error", title: "Records Obtained Work Order Failed to Load" });
                }

                setIsBtn(false);

            })
            .catch(function (error) {
                setIsBtn(false);
                catchError(error, navigate);
            });
    };


    useEffect(() => {

        getWorkOrders();

    }, []);

    return (
        <>
             <TopBar />


            <div className="row py-4 start-0  mx-auto ">

                <div className="col-md-6 col-sm-12  ">
                    <h3 className="text-dark my-0">RECORD OBTAINED WORK ORDERS</h3>
                </div>

                <div className="col-md-6 col-sm-12 ps-3 text-end">

                    <span className="btn btn-primary rounded-0 me-1">
                        <NavLink className="nav-link" smooth to="/admin/work-orders-new">
                            NEW
                        </NavLink>
                    </span>
                    <span className="btn btn-danger rounded-0  me-1 ">
                        <NavLink className="nav-link" smooth to="/admin/work-orders-search">
                            SEARCH
                        </NavLink>
                    </span>

                </div>

            </div>


            <div className="card card-form card-primary mb-3">
                <div className="card-body">
                    <form className="form-horizontal form-thick mb-2"  >

                        <div className="row px-5 gx-5">

                            <div className="col-xl-3  col-lg-3 col-sm-12 my-1">
                                <label htmlFor="client" >Client</label>
                                <input name="client" className="form-control" type="text"
                                    value={woSearch?.client}
                                    onChange={(e) =>
                                        setWoSearch({ ...woSearch, client: e.target.value })
                                    }

                                />


                            </div>
                            <div className="col-xl-3  col-lg-3 col-sm-12 my-1">
                                <label htmlFor="case_manager">Case Manager</label>
                                <input name="case_manager" className="form-control" type="text"
                                    value={woSearch?.case_manager}
                                    onChange={(e) =>
                                        setWoSearch({ ...woSearch, case_manager: e.target.value })
                                    }
                                />
                            </div>
                            <div className="col-xl-2  col-lg-2 col-sm-12 my-1">
                                <label htmlFor="facility">Facility</label>
                                <input name="facility" className="form-control" type="text"
                                    value={woSearch?.facility}
                                    onChange={(e) =>
                                        setWoSearch({ ...woSearch, facility: e.target.value })
                                    }


                                />



                            </div>



                            <div className="col-xl-2  col-lg-2 col-sm-12 my-1">
                                <label htmlFor="invoice_date_range">Invoice From</label>

                                <DatePicker name="from" id="from" type="text"
                                    className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selectsStart
                                    isClearable={true}
                                    selected={woSearch?.from}
                                    onChange={(e) => {
                                        {
                                            var dt = new Date(e);

                                            const year = dt.getFullYear();
                                            const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                                            const day = dt.getDate().toString().padStart(2, "0");

                                            const formatted_date = month + '/' + day + '/' + year

                                            setWoSearch({ ...woSearch, from: formatted_date })

                                        }

                                    }
                                    }
                                />
                            </div>
                            <div className="col-xl-2  col-lg-2 col-sm-12 my-1">
                                <label htmlFor="invoice_date_range">Invoice To</label>

                                <DatePicker name="to" id="to" type="text"
                                    className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selectsEnd
                                    isClearable={true}
                                    selected={woSearch?.to}
                                    onChange={(e) => {
                                        {
                                            var dt = new Date(e);

                                            const year = dt.getFullYear();
                                            const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                                            const day = dt.getDate().toString().padStart(2, "0");

                                            const formatted_date = month + '/' + day + '/' + year

                                            setWoSearch({ ...woSearch, to: formatted_date })

                                        }
                                    }
                                    }
                                />
                            </div>



                        </div>


                    </form>

                </div>

                <div className="card-footer">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-sm-12 text-center">
                            <button onClick={() => getWorkOrdersFiltered()} className="btn btn-success mx-1" type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "FILTER"} </button>
                            {csvData && role >= 0 &&
                                <CSVLink data={csvData} headers={csvHeader} className="btn btn-warning mx-1" >Download</CSVLink>
                            }
                        </div>

                    </div>
                </div>
            </div>


            {data &&

                <div className="card border-4 border-dark rounded-1 card-success mb-4" >

                    <div className="card-body p-0" >
                        <CustomTable columns={columns} data={data} />

                    </div>
                </div>


            }
        </>
    );
};

export default RecordsInvoiceNeeded;